import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/hd_prev_btn.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { class: "header_wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "logo" }, "META HEALTH", -1)
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { id: "user_form" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "result_txt" }, [
  /*#__PURE__*/_createElementVNode("b", null, "회원 가입 완료되었습니다."),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 승인 완료 시 이메일로 안내 드리겠습니다. ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "check_form_info" }, "관리자 승인 이후 서비스 이용이 가능합니다.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GnbLayout = _resolveComponent("GnbLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "menu_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("button", {
              type: "button",
              id: "submit_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login')))
            }, "로그인"),
            _hoisted_11
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout)
  ], 64))
}